export const UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT = 'UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT';
export type UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT = typeof UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT;

export const UPDATE_PROJECT_TEAM_MEMBER_SUCCESS = 'UPDATE_PROJECT_TEAM_MEMBER_SUCCESS';
export type UPDATE_PROJECT_TEAM_MEMBER_SUCCESS = typeof UPDATE_PROJECT_TEAM_MEMBER_SUCCESS;

export const UPDATE_PROJECT_TEAM_MEMBER_FAILURE = 'UPDATE_PROJECT_TEAM_MEMBER_FAILURE';
export type UPDATE_PROJECT_TEAM_MEMBER_FAILURE = typeof UPDATE_PROJECT_TEAM_MEMBER_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/team-member/update/Types.tsx